import React, { Component } from 'react';
import IndexHouse1 from '../assets/images/home/index_house.png';
import IndexHouse2 from '../assets/images/projects/caselle_bifamiliare_1.png';
import IndexHouse3 from '../assets/images/home/index_house.png';

export default class IntroHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            images: [IndexHouse1, IndexHouse2, IndexHouse3],
            activeIndex: 0
        };
    }

    componentDidMount() {
        this.interval = setInterval(this.nextSlide, 3000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    nextSlide = () => {
        const { images, activeIndex } = this.state;
        const newIndex = (activeIndex + 1) % images.length;
        this.setState({ activeIndex: newIndex });
    };

    render() {
        const { images, activeIndex } = this.state;
        return (
            <div className="intro" id="home">
                {images.map((image, index) => (
                    <div
                        key={index}
                        className={`intro-slide ${index === activeIndex ? 'active' : ''}`}
                        style={{ backgroundImage: `url(${image})` }}
                    />
                ))}
                <div className="intro-content">
                    <p className="display-3 intro-title intro-text">EDILPAGOTTO</p>
                    <p className="lead intro-text intro-paragraph">
                        COSTRUZIONI EDILI, CIVILI, INDUSTRIALI E RESTAURI
                    </p>
                </div>
            </div>
        );
    }
}
